module.exports = __webpack_public_path__ + "static/img/IMG_20150610_234907.ec14f3f9.jpg";